import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FormikProps } from "formik";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { CustomerTellUsMoreData as Type } from "../new-customer-model";
import Typography from "@mui/material/Typography";
import { useTranslation } from "next-i18next";

interface Props {
  formik: FormikProps<Type>;
}

export function NewCustomerTellUsMoreStep({ formik }: Props) {
  const { t } = useTranslation();
  return (
    <Box>
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "1.75em",
            fontWeight: "bold",
          }}
        >
          {t("request_access:customer_access.tell_us_more")}
        </Typography>
      </Box>
      <Box sx={{ fontSize: "14px", mb: "12px", textAlign: "left" }}></Box>
      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            marginBottom: "20px",
          }}
        >
          {/* Business Website */}
          <InputLabel
            sx={{ textAlign: "left", mt: "1rem" }}
            htmlFor="businessWebsite"
          >
            {t("request_access:customer_access.business_website")}
          </InputLabel>
          <TextField
            fullWidth
            id="businessWebsite"
            value={formik.values.businessWebsite}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Box>

        {/* How did you hear about us  */}
        <InputLabel
          sx={{ textAlign: "left", mt: "1rem" }}
          htmlFor="howDidYouHear"
        >
          {t("request_access:customer_access.how_did_you_hear")}
        </InputLabel>
        <Select
          sx={{
            paddingLeft: "0",
            paddingTop: "4px",
            paddingBottom: "4px",
            textAlign: "left",
          }}
          id="howDidYouHear"
          name="howDidYouHear"
          value={formik.values.howDidYouHear}
          fullWidth
          onChange={async (e) => {
            formik.handleChange(e);
            formik.setFieldValue("address", "");
          }}
        >
          <MenuItem value={"Social Media"}>Social Media</MenuItem>
          <MenuItem value={"Other"}>Other</MenuItem>
          <MenuItem value={"Referral"}>Referral</MenuItem>
        </Select>
        {/* Additional Info */}
        <InputLabel
          sx={{ textAlign: "left", mt: "1rem" }}
          htmlFor="additionalInfo"
        >
          {t("request_access:customer_access.additional_info")}
        </InputLabel>
        <TextField
          inputProps={{ maxLength: 200 }}
          fullWidth
          helperText={`${
            formik.values.additionalInfo?.length == undefined
              ? 0
              : formik.values.additionalInfo.length
          }/${200} `}
          id="additionalInfo"
          multiline
          value={formik.values.additionalInfo}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <Box mt={12}>
          <Button
            sx={{ width: "100%", mb: 4 }}
            type="submit"
            disabled={!(formik.dirty && formik.isValid)}
          >
            {t("common:common.continue")}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
